module.exports = __webpack_public_path__ + "static/media/03_swipe-ID.95157c4b.gif";